import { zTagType } from '@strength/domain';
import type { TagType } from '@strength/domain';

/**
 * `metric_category` tags back the admin metric-category picker. They live in
 * the same table as library tags, so every type list on the library tags page
 * has to filter them out explicitly — otherwise categories leak into the grid.
 */
export const excludedTagTypes: TagType[] = ['metric_category'];

export const libraryTagTypes: TagType[] = zTagType.options.filter(
  (type) => !excludedTagTypes.includes(type),
);

/**
 * An empty selection means "no type filter", and the API reads `undefined` as
 * "every type" — categories included. Widening to `libraryTagTypes` instead
 * keeps the unfiltered grid to the same types as the filter dropdown.
 */
export const resolveTagTypeFilter = (selectedTypes: TagType[]): TagType[] =>
  selectedTypes.length > 0 ? selectedTypes : libraryTagTypes;
